import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUserPlus, 
  faEdit, 
  faTrashAlt, 
  faSave, 
  faTimes,
  faUserTie
} from '@fortawesome/free-solid-svg-icons';
import { Modal, Button } from 'react-bootstrap';
import "./TeamList.css";
import { 
  getUserAllTeamMembers_GET,
  addTeamMember_POST,
  updateTeamMember_PUT,
  deleteTeamMember_DELETE
} from '../../api';
import { toast } from 'react-toastify';

export default function TeamList() {
  const [members, setMembers] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [isAdding, setIsAdding] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    position: '',
    contact_no: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [memberToDelete, setMemberToDelete] = useState(null);

  // Custom colors
  const primaryColor = '#055837';
  const secondaryColor = '#FFCC01';
  const primaryHover = '#04482e';
  const secondaryHover = '#e6b800';

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Add new member
  const handleAdd = () => {
    setIsAdding(true);
    setEditingId(null);
    setFormData({ name: '', position: '', contact_no: '' });
  };

  // Edit existing member
  const handleEdit = (member) => {
    setIsAdding(false);
    setEditingId(member.id);
    setFormData({
      name: member.name,
      position: member.position,
      contact_no: member.contact_no
    });
  };

  // Save member (both add and edit)
  const handleSave = async () => {
    if (!formData.name || !formData.position || !formData.contact_no) {
      alert('Please fill all fields');
      return;
    }


    setIsLoading(true);
    try {
      const formPayload = new FormData();
      formPayload.append("name", formData.name);
      formPayload.append("position", formData.position);
      formPayload.append("contact_no", formData.contact_no);

      if (isAdding) {
        const response = await addTeamMember_POST(formPayload);
        
        if (response?.data?.response?.response === true) {
          await fetchTeamMembers();
          setIsAdding(false);
        }
        else{
          // console.log(response?.data?.response?.response);
          toast.error(response?.data?.response?.error_msg);
        }
      } else {
        formPayload.append("id", editingId);
        const response = await updateTeamMember_PUT(formPayload);
        if (response?.data?.response?.response === true) {
          await fetchTeamMembers();
          setEditingId(null);
        }
        else{
          toast.error(response?.data?.response?.error_msg);
        }
      }
    } catch (error) {
      console.error('Error saving member:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Delete click handler
  const handleDeleteClick = (id) => {
    setMemberToDelete(id);
    setShowDeleteModal(true);
  };

  // Confirm delete
  const handleDeleteConfirm = async () => {
    if (!memberToDelete) return;
    
    setIsLoading(true);
    try {
      const formPayload = new FormData();
      formPayload.append("id", memberToDelete);
      
      const response = await deleteTeamMember_DELETE(formPayload);
      if (response?.data?.response?.response === true) {
        await fetchTeamMembers();
      }
    } catch (error) {
      console.error('Error deleting member:', error);
    } finally {
      setIsLoading(false);
      setShowDeleteModal(false);
      setMemberToDelete(null);
    }
  };

  // Cancel operation
  const handleCancel = () => {
    setEditingId(null);
    setIsAdding(false);
  };

  // Fetch all team members
  const fetchTeamMembers = async () => {
    setIsLoading(true);
    try {
      const response = await getUserAllTeamMembers_GET();
      if (response?.data?.response?.response === true) {
        setMembers(response?.data?.response?.data || []);
      }
    } catch (error) {
      console.error('Error fetching team members:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Initial data load
  useEffect(() => {
    fetchTeamMembers();
  }, []);

  return (
    <div className="container mt-4">
      <div className="card" style={{ borderColor: primaryColor, marginBottom: "60px" }}>
        <div className="card-header text-white" style={{ backgroundColor: primaryColor }}>
          <h5 className="mb-0">
            {/* <FontAwesomeIcon icon={faUserTie} className="me-2" /> */}
            <i className="bi bi-people-fill me-2"/>
            Team Members
          </h5>
        </div>
        
        <div className="card-body">
          <div className="d-flex justify-content-end mb-3">
            <button 
              onClick={handleAdd}
              className="btn btn_yellow_green"
              style={{ 
                backgroundColor: secondaryColor,
                borderColor: secondaryColor,
                ':hover': {
                  backgroundColor: secondaryHover,
                  borderColor: secondaryHover
                }
              }}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={faUserPlus} className="me-2" />
              
              Add Team Member
            </button>
          </div>

          {isAdding && (
            <div className="card mb-4" style={{ borderColor: primaryColor }}>
              <div className="card-header" style={{ backgroundColor: `${primaryColor}20` }}>
                <h5 className="mb-0">New Team Member</h5>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter full name"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Position</label>
                    <input
                      type="text"
                      name="position"
                      value={formData.position}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter position"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Contact No.</label>
                    <input
                      type="text"
                      name="contact_no"
                      value={formData.contact_no}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter contact number"
                    />
                  </div>
                </div>
              </div>
              <div className="card-footer text-end">
                <button
                  onClick={handleCancel}
                  className="btn btn-outline-secondary me-2"
                  disabled={isLoading}
                >
                  <FontAwesomeIcon icon={faTimes} className="me-1" />
                  Cancel
                </button>
                <button
                  onClick={handleSave}
                  className="btn btn_green_yellow text-white"
                  style={{ 
                    backgroundColor: primaryColor,
                    borderColor: primaryColor,
                    ':hover': {
                      backgroundColor: primaryHover,
                      borderColor: primaryHover
                    }
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? 'Saving...' : (
                    <>
                      <FontAwesomeIcon icon={faSave} className="me-1" />
                      Save
                    </>
                  )}
                </button>
              </div>
            </div>
          )}

          <div className="table-responsive">
            <table className="table table-hover team_member_table">
              <thead style={{ backgroundColor: primaryColor, color: 'white' }}>
                <tr>
                  <th>Full Name</th>
                  <th>Position</th>
                  <th>Contact No.</th>
                  <th width={80}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {isLoading && members.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center py-4">
                      Loading...
                    </td>
                  </tr>
                ) : members.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center text-muted py-4">
                      No team members found
                    </td>
                  </tr>
                ) : (
                  members.map((member,index) => (
                    <tr key={member.id} className={index === 0 ? 'font-weight-bold' : ''}>
                      <td>
                        {editingId === member.id ? (
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            className="form-control form-control-sm"
                          />
                        ) : (
                          member.name
                        )}
                      </td>
                      <td>
                        {editingId === member.id ? (
                          <input
                            type="text"
                            name="position"
                            value={formData.position}
                            onChange={handleInputChange}
                            className="form-control form-control-sm"
                          />
                        ) : (
                          member.position
                        )}
                      </td>
                      <td>
                        {editingId === member.id ? (
                          <input
                            type="text"
                            name="contact_no"
                            value={formData.contact_no}
                            onChange={handleInputChange}
                            className="form-control form-control-sm"
                          />
                        ) : (
                          member.contact_no
                        )}
                      </td>
                      <td>
                        {editingId === member.id ? (
                          <div className="d-flex gap-2">
                            <button
                              onClick={handleSave}
                              className="btn btn-sm btn_green_yellow text-white"
                              style={{ 
                                backgroundColor: primaryColor,
                                borderColor: primaryColor
                              }}
                              disabled={isLoading}
                            >
                              {isLoading ? 'Saving...' : (
                                <>
                                  <FontAwesomeIcon icon={faSave} className="me-1" />
                                  {/* Save */}
                                </>
                              )}
                            </button>
                            <button
                              onClick={handleCancel}
                              className="btn btn-sm btn-outline-danger"
                              disabled={isLoading}
                            >
                              <FontAwesomeIcon icon={faTimes} />
                            </button>
                          </div>
                        ) : (
                          <div className="d-flex gap-2">
                            <button
                              onClick={() => handleEdit(member)}
                              className="btn btn-sm btn_yellow_green"
                              style={{ 
                                backgroundColor: secondaryColor,
                                borderColor: secondaryColor
                              }}
                              disabled={isLoading || (index === 0) ? true : false}
                            >
                              <FontAwesomeIcon icon={faEdit} />
                              {/* Edit */}
                            </button>
                            <button
                              onClick={() => handleDeleteClick(member.id)}
                              className="btn btn-sm btn-danger"
                              disabled={isLoading || (index === 0) ? true : false}
                            >
                              <FontAwesomeIcon icon={faTrashAlt} />
                              {/* Delete */}
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal 
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        animation={false}
        backdrop="static"
        centered
        size="lg"
      >
        <Modal.Header style={{
          backgroundColor: secondaryColor,
          color: primaryColor
        }}>
          <Modal.Title className='mx-auto d-block'>
            <h5 className="modal-title text-uppercase"><b>Confirm Delete</b></h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12 text-center" style={{fontWeight: 'bold', fontSize: 15}}>
              <h5>
                Are you sure you want to delete this team member?
              </h5>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="light"
            className="me-3"
            onClick={() => setShowDeleteModal(false)}
            onMouseEnter={(e) => (e.target.style.transform = "scale(1.02)")}
            onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
          >
            Cancel
          </Button>
          <Button
            className="btn_green_yellow"
            style={{
              backgroundColor: primaryColor,
              color: secondaryColor,
              transition: "transform 0.2s",
            }}
            onClick={handleDeleteConfirm}
            disabled={isLoading}
            onMouseEnter={(e) => (e.target.style.transform = "scale(1.02)")}
            onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}